<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <el-row class="mg-t-10">
            <el-col :span="12">
                <el-card class="mycard-a canmou-card">

                    <!--参谋表单-->

                    <div class="cm-card-icon">
                        <img src="@/assets/cm-form-icon.png">
                    </div>

                    <el-form ref="form" :label-position="'top'" label-width="80px" class="myform">
                        <div class="cm-title">采购参谋</div>

                        <div class="cm-desc">对人工计划采购的数量自动进行风险评估，结合实际情况对比分析并给出结果建议</div>

                        <el-form-item label="选择商品*">
                            <el-input style="width: 280px" v-model="sel_goodsName" readonly></el-input>
                            <el-button class="mybtn-green2" @click="selectGoods">选择</el-button>
                        </el-form-item>

                        <div class="cm-chart">
                            当前剩余库存：<span class="cm-chart-val">{{sel_leftQtt||0}}</span> <br/>
                            保质期：<span class="cm-chart-val">{{sel_qaDay||0}}</span> <br/>
                            最佳销售期：<span class="cm-chart-val">{{sel_bestSelling||0}}</span>
                        </div>

                        <div class="cm-tip">（以下内容计划采购数量必填，生产日期或计划售罄日期选填其中一个进行分析）</div>

                        <el-form-item label="计划采购数量">
                            <el-input value="50" style="width: 280px;" v-model="input_stock"></el-input>
                            <span style="color: #29CF87;margin-left: 20px" v-if="input_stock>0">已填写</span>
                        </el-form-item>

                        <el-form-item label="生产日期">
                            <el-date-picker type="date" placeholder="选择时间" style="width: 280px;" v-model="input_prodDate"></el-date-picker>
                            <span style="color: #29CF87;margin-left: 20px" v-if="input_prodDate">已填写</span>
                        </el-form-item>

                        <el-form-item label="计划售罄日期">
                            <el-date-picker type="date" placeholder="选择时间" style="width: 280px;" v-model="input_selloutDate"></el-date-picker>
                            <span style="color: #29CF87;margin-left: 20px" v-if="input_selloutDate">已填写</span>
                        </el-form-item>

                        <el-form-item style="padding-top: 20px">
                            <el-button class="mybtn-blue2" style="width: 280px;" @click="startAdvice">分析</el-button>
                        </el-form-item>
                    </el-form>

                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="mycard-a canmou-report-card">

                    <!--分析报告-->

                    <div class="crc-title">分析报告</div>

                    <div class="crc-content">
                        <ul v-if="rpt.curDate">
                            <li v-if="prod||sell">分析时间：{{rpt.curDate}}</li>
                            <li v-if="prod||sell">商品：{{rpt.goodsName}}</li>
                            <li v-if="prod">生产日期：{{rpt.prodDate}}</li>
                            <li v-if="prod">剩余保质期：<span v-if="rpt.surplus==''">未知</span><span v-else>{{rpt.surplus}}天</span></li>
                            <li v-if="prod||sell">计划采购数量：{{rpt.stock}}</li>
                            <li v-if="sell">建议采购量：{{rpt.addNum}}</li>
                            <li v-if="prod||sell">预计售完时间：{{rpt.cycle}}天</li>
                            <li v-if="prod">临期风险：
                                <span style="color: #888888;" v-if="rpt.risk==0">未知</span>
                                <span style="color: #29CF87;" v-if="rpt.risk==1">低</span>
                                <span style="color: #29CF87;" v-if="rpt.risk==2">中</span>
                                <span style="color: red;" v-if="rpt.risk==3">高</span>
                                <span style="color: red;" v-if="rpt.risk==4">极高</span>
                            </li>
                            <li v-if="sell">是否在计划时间内售完：<span style="color: #29CF87;">{{rpt.sellout?'是':'否'}}</span></li>
                        </ul>
                        <div v-if="!rpt.curDate" style="height: 252px;">
                            请先分析
                        </div>
                    </div>

                    <div class="crc-desc">
                        说明：<br/>
                        <br/>
                        临期风险评判标准：通过计算分析得出预计售完时间与商品最佳销售期对比，风险等级划分为三级：<br/>
                        低：预计售完时间＜剩余保质期＜最佳销售期<br/>
                        中：预计售完时间＜剩余保质期＞最佳销售期<br/>
                        高：预计售完时间＞剩余保质期＞最佳销售期<br/>
                        <br/>
                        以上分析结果仅作为参考，请结合实际情况决策。
                    </div>

                </el-card>
            </el-col>
        </el-row>

        <!--选择商品对话框-->
        <el-dialog title="选择商品"
                   :visible.sync="selGoodsDialogVisible"
                   class="mydialog" width="880px"
                   :append-to-body="true">
            <div style="margin-bottom: -15px">
                <!--查询条件-->
                <el-form :inline="true" class="myform">
                    <el-form-item label="来源">
                        <el-select placeholder="请选择" v-model="selGoods$query_dataSource">
                            <el-option v-for="(item,idx) in data_dataSource" :key="idx" :label="item.value" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关键字">
                        <el-input placeholder="商品名称/条码" v-model="selGoods$query_condition"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="fetchData_goods">搜索</el-button>
                    </el-form-item>
                </el-form>
                <!--table、分页-->
                <el-table :data="selGoods$data" v-loading="selGoods$loading" size="medium"
                          style="min-height: 0;margin: 10px 0px;" height="270"
                          highlight-current-row
                          @current-change="handleCurrentChange_goods">
                    <el-table-column prop="goodsName" label="商品" width="180" align="center" header-align="center"> </el-table-column>
                    <el-table-column prop="barcode" label="条码货号" width="180" align="center" header-align="center"> </el-table-column>
                    <el-table-column prop="skuVname" label="规格" width="100" align="center" header-align="center"> </el-table-column>
                    <el-table-column prop="unitName" label="单位" width="60" align="center" header-align="center"> </el-table-column>
                    <el-table-column prop="leftQtt" label="当前库存" width="80" align="center" header-align="center"> </el-table-column>
                    <el-table-column label="保质期" width="80" align="center" header-align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.qaUnit==1">{{scope.row.qaDay}}天</span>
                            <span v-if="scope.row.qaUnit==2">{{scope.row.qaDay}}月</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bestSelling" label="最佳销售期" align="center" header-align="center"> </el-table-column>
                </el-table>
                <el-pagination style="float: right;margin: 14px"
                               background
                           layout="total, sizes, prev, pager, next"
                           :page-size="selGoods$page_size"
                           :current-page="selGoods$curr_page"
                           :total="selGoods$total"
                            @current-change="handlePageChange_goods"></el-pagination>
                <div style="clear: both"></div>
            </div>
            <div slot="footer">
                <el-button class="mybtn-blue2" style="width: 100px" @click="selectGoods_ok">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {formatDate} from '@/common/filters'
export default {
    data: function () {
        return {
            // 下拉框等数据
            data_dataSource: [],
            // 表格数据（选择商品）
            selGoodsDialogVisible: false,
            selGoods$query_dataSource: '',
            selGoods$query_condition: '',
            selGoods$page_size: 5,
            selGoods$curr_page: 1,
            selGoods$loading: false,
            selGoods$total: 0,
            selGoods$data: [],
            selGoods$currentRow: null,
            sel_skuId:'',
            sel_dataSource:'',
            sel_goodsName:'',
            sel_leftQtt:'',
            sel_qaDay:'',
            sel_bestSelling:'',
            // input
            input_prodDate : '',
            input_stock : '',
            input_selloutDate : '',
            // 分析报告
            rpt:{ },
            prod:'',
            sell:'',
        }
    },
    methods:{
        selectGoods: function () {
            this.selGoodsDialogVisible = true;
            this.fetchData_goods();
        },
        selectGoods_ok: function () {
            let record = this.selGoods$currentRow
            if (!record) {
                this.xEui.msg_error('请选择商品')
                return
            }

            this.sel_skuId = record.skuId;
            this.sel_dataSource = record.dataSource;
            this.sel_goodsName = record.goodsName;
            this.sel_leftQtt = record.leftQtt;
            this.sel_qaDay = record.qaDay + (record.qaUnit == 1 ? '天' : '月');
            this.sel_bestSelling = record.bestSelling + '天';

            // 隐藏对话框
            this.selGoodsDialogVisible = false
        },
        fetchData_goods: function () {
            let self = this;

            self.selGoods$loading = true

            self.xFetch.post(self.xApi('/robot/goods/getGoodsWithStock'), {
                page: self.selGoods$curr_page,
                rows: self.selGoods$page_size,
                dataSource: self.selGoods$query_dataSource,
                condition: self.selGoods$query_condition,
            },{xPostType:'form'}).then(function (res) {
                self.selGoods$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.selGoods$total = 0;
                    self.selGoods$data = [];
                }
                else {
                    self.selGoods$total = res.data.total;
                    self.selGoods$data = res.data.rows;
                }
            });
        },
        handlePageChange_goods: function (val) {
            this.selGoods$curr_page = val;
            this.fetchData_goods();
        },
        handleCurrentChange_goods: function (val) {
            this.selGoods$currentRow = val
        },
        startAdvice: function () {
            let self = this

            // check
            if(!self.sel_skuId){
                self.xEui.msg_error('请选择商品')
                return;
            }
            if(!self.input_stock){
              self.xEui.msg_error('请输入采购数量')
              return;
            }

            if(!self.input_prodDate&&!self.input_selloutDate){
                self.xEui.msg_error('请选择生产日期或售罄日期其中一个')
                return;
            }
//            if(!self.input_prodDate){
//                self.xEui.msg_error('请选择生产日期')
//                return;
//            }
//            if(!self.input_selloutDate){
//                self.xEui.msg_error('请选择售罄日期')
//                return;
//            }

            if(self.input_prodDate!=''){
              self.prod=true;
              self.sell=false;
            }
            if(self.input_selloutDate!=''){
              self.prod=false;
              self.sell=true;
            }
            if(self.input_prodDate!=''&&self.input_selloutDate!=''){
              self.prod=true;
              self.sell=true;
            }
            // 开始分析
            self.xEui.myloading('分析中...');
            self.xFetch.post(self.xApi('/robot/purchase/getAdvice'), {
                dataSource: self.sel_dataSource,
                skuId: self.sel_skuId,
                prodDate: self.input_prodDate==''?'':formatDate(self.input_prodDate),
                stock: self.input_stock,
                selloutDate: self.input_selloutDate==''?'':formatDate(self.input_selloutDate),
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close()

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else{
                    self.xEui.msg_success('分析完成')
                    self.rpt = res.data.data;
                    self.input_stock='';
                    self.input_prodDate='';
                    self.input_selloutDate='';
                }
            });
        }
    },
    created: function(){
        let self = this

        // 下拉框数据来源
        self.xFetch.post(self.xApi('/robot/common/getDataSource'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_dataSource = res.data.data;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*canmou-card*/
    .canmou-card{ margin-right: 5px; height: 850px;position: relative; }
    .canmou-card .cm-card-icon{ position: absolute;left: 30px;top: 30px }
    .canmou-card .cm-card-icon img{ width: 70px;}
    .canmou-card .myform{ margin: 10px 10px 10px 110px;font-size: 14px; }
    .canmou-card .cm-title{ font-size: 16px;color: #303133;font-weight: 700;margin-bottom: 15px }
    .canmou-card .cm-desc{ color: #606266;}
    .canmou-card .cm-chart{color:#707090;line-height: 26px; }
    .canmou-card .cm-chart .cm-chart-val{ color: #303133}
    .canmou-card .cm-tip{ color: #303133; padding-top: 20px;padding-bottom: 20px }
    /*canmou-report-card*/
    .canmou-report-card{ margin-left: 5px; height: 850px;font-size: 14px; }
    .canmou-report-card .crc-title{ font-size: 16px;color: #409EFF;font-weight: 700; }
    .canmou-report-card .crc-content{ padding-top: 30px;padding-bottom: 30px;margin-bottom: 30px;border-bottom: 1px solid #EAEAEA; }
    .canmou-report-card .crc-content ul{ padding: 0;margin: 0;list-style: none  }
    .canmou-report-card .crc-content ul li{ color: #303133;line-height: 28px }
    .canmou-report-card .crc-desc{ color: #707090  }
</style>
<style>
    /*canmou-card*/
    .canmou-card .el-form-item__label{ color: #707090 }
    /*canmou-report-card*/
    .canmou-report-card .el-card__body{ padding: 30px}
</style>



// WEBPACK FOOTER //
// src/views/purchase/canmou.vue